
import React from 'react';

// import NonFSIndex from '../../components/NonFSIndex';

export default function ArmorTypeIndex() {
  // return (
  //   <NonFSIndex
  //     data_type="armor_type"
  //   />
  // );
  return <></>;
}
